module.exports = __webpack_public_path__ + "assets/img/8a06-am.svg";